module.exports = __webpack_public_path__ + "img/num.4b7eb4ae.png";